import './DeployApproach.css';
import img1 from '../deployassets/deployapproach1.png';
import img2 from '../deployassets/deployapproach2.png';
import img3 from '../deployassets/deployapproach3.png';
import img4 from '../deployassets/deployapproach4.png';

export default function DeployApproach() {
  const cards = [
    {
      id: 1,
      img:img1,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
    },
    {
      id: 2,
      img:img2,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
    },
    {
      id: 3,
      img:img3,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
    },
    {
      id: 4,
      img:img4,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
    }
  ];

  return (
    <div id="deploy-approach" className='outsourcemainclass'>
      <div className="left">
        <h2 className="heading">Our CD Implementation Approach</h2>
        <p className="subheading">
        A structured and strategic CD implementation approach that ensures seamless automation, secure deployments, continuous monitoring, and scalable release pipelines aligned with business objectives.
        </p>
        <button>Book your free consultation</button>
      </div>
      <div className="right">
        <div className="cards">
          {cards.map((card) => (
            <div key={card.id} className="card">
                <img src={card.img} alt="error" />
              <h1>{card.percentage}</h1>
              <span>{card.description}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}